/**
 * "Draw offer from <name>" + Accept / Decline (fix G / G6, 2026-10-06).
 *
 * TWO rows, not the one `cardStyles.rowCard` row every other dock card uses:
 * a long display name next to two buttons in a single 40 px-tall row left no
 * room for either line of text, so both truncated. The text block gets the
 * card's full width on its own row (the title can wrap to 2 lines); the
 * buttons move to a right-aligned row underneath. `DOCK_HEIGHT` grew to fit
 * (`../dockEvents.ts`) — this is the one card that needed it, and the slot is
 * fixed-height regardless of which card is showing.
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {SPACE} from '../../../../theme/tokens';
import {Button, Txt} from '../../../../ui';
import {DrawOfferCardModel} from './DrawOfferCard.model';

export type DrawOfferCardViewProps = DrawOfferCardModel & {
  opponentName: string;
};

export default React.memo(function DrawOfferCardView({
  opponentName,
  onAccept,
  onDecline,
}: DrawOfferCardViewProps) {
  return (
    <View style={styles.card}>
      <View style={styles.text}>
        <Txt variant="label" numberOfLines={2}>
          {`Draw offer from ${opponentName}`}
        </Txt>
        <Txt variant="captionTight" tone="muted" numberOfLines={1}>
          Moving declines
        </Txt>
      </View>
      <View style={styles.buttons}>
        <Button label="Accept" size="sm" onPress={onAccept} />
        <Button
          label="Decline"
          size="sm"
          variant="outline"
          onPress={onDecline}
        />
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  card: {
    flex: 1,
    minWidth: 0,
    gap: SPACE.xs,
  },
  text: {
    minWidth: 0,
    gap: 2,
  },
  buttons: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: SPACE.sm,
  },
});
